import { Component , Input, OnInit, Output,EventEmitter} from '@angular/core';
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';

import { map } from 'rxjs/operators';
import { SiteService } from 'src/app/new-sites-management/common/services/site.service';
import { MediaService } from '../../common/media.service';
import { AddEditFolderComponent } from './add-edit-folder/add-edit-folder.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-folders',
  templateUrl: './folders.component.html',
  styleUrls: ['./folders.component.css']
})
export class FoldersComponent implements OnInit {

  constructor(
    public siteService: SiteService,
    public mediaManagerService: MediaService,
    private dialog: MatDialog,
    private snotifyService: ToastrService,) { }

  ngOnInit() {
  }

  getSubItems(folder) {
       if (folder.id != this.mediaManagerService.folder.parentId) {
      this.mediaManagerService.searchMediaAndFolders(folder.id).subscribe((res: any) => {
        this.mediaManagerService.isParentIdChanged(folder.id, folder.name, 
          res.parentFolderId,folder.itemCount,          res.currentFolderBreadcrumb
          );
      });
    }
  }

  manageFolder(method) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.panelClass = "modal-media";

    dialogConfig.data = {
      method: method,
      folder: this.mediaManagerService.folder,
    };
    this.dialog.open(AddEditFolderComponent, dialogConfig)
      .afterClosed()
      .subscribe(
        res => {

        }
      )
  }


  public deleteFolder(ids:number[],action) {
    this.mediaManagerService.deleteFolder(ids,action).subscribe(
      (res: any) => {
        this.openNotifySuccess(res.status.body);
         this.mediaManagerService.folder.parentId = res.currentFolderId;
        this.mediaManagerService
          .searchMediaAndFolders(
         
          )
          .subscribe();
         this.mediaManagerService.getFoldersFirstTime();
         this.mediaManagerService.getAllSideFolders();
          // this.mediaManagerService.folder$.

      } 
    );
  }

  public drop(event, folderId) {
       var drag = [];
    drag.push(event.dragData.toString());
    this.mediaManagerService
      .moveMedia(drag, folderId || 0)
      .subscribe((res: any) => {
        this.openNotifySuccess('Media successfully moved.');
        this.mediaManagerService
          .getMediaById(
            this.mediaManagerService.folder.parentId
              ? this.mediaManagerService.folder.parentId
              : 0
          )
          .subscribe();
        this.mediaManagerService.getFoldersFirstTime();
      });
  }
  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

 
}
